/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Layout_Stop_ImpersonationInputs */

const en_admin_company_layout_stop_impersonation = /** @type {(inputs: Admin_Company_Layout_Stop_ImpersonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop impersonation`)
};

const de_admin_company_layout_stop_impersonation = /** @type {(inputs: Admin_Company_Layout_Stop_ImpersonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung als anderer Benutzer beenden`)
};

/**
* | output |
* | --- |
* | "Stop impersonation" |
*
* @param {Admin_Company_Layout_Stop_ImpersonationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_layout_stop_impersonation = /** @type {((inputs?: Admin_Company_Layout_Stop_ImpersonationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Layout_Stop_ImpersonationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_layout_stop_impersonation(inputs)
	return en_admin_company_layout_stop_impersonation(inputs)
});